/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

export const AppContext = React.createContext(
{
  websiteProfile: {},
  userUiProfile: {},
  fetchWebsiteProfile: () => {},
  dbTwig: undefined,
  appLocalStorage: () => {}
});